import { types } from '../types'

let initialState = {
    instructionDataObject: [],
    displayDataList: [],
    callBoxStatus: false,
    callTransferStatus: null

}

const reportReducer = (state = initialState, { type, action, error, instruction, params }) => {
    switch (type) {

        case types.GET_CUSTOMER_IDENTITY_INFO_REQUEST: {
            return {
                ...state,
                getIdentityInfoWaiting: true,
                getIdentityInfoSuccess: false,
                getIdentityInfoError: ''

            }
        }
        case types.GET_CUSTOMER_IDENTITY_INFO_SUCCESS: {

            return {
                ...state,
                getIdentityInfoWaiting: false,
                getIdentityInfoSuccess: true,
                customerIdentityInfo: action.data,
            }
        }
        case types.GET_CUSTOMER_IDENTITY_INFO_ERROR: {
            return {
                ...state,
                getIdentityInfoWaiting: false,
                getIdentityInfoError: 'error',

            }
        }
        case types.GET_CALL_HISTORY_BY_NUMBER_REQUEST: {
            return {
                ...state,
                getCallHistoryWaiting: true,
                getCallHistorySuccess: false,
                getCallHistoryError: ''

            }
        }
        case types.GET_CALL_HISTORY_BY_NUMBER_SUCCESS: {

            return {
                ...state,
                getCallHistoryWaiting: false,
                getCallHistorySuccess: true,
                callHistory: action.data,
            }
        }
        case types.GET_CALL_HISTORY_BY_NUMBER_ERROR: {
            return {
                ...state,
                getCallHistoryWaiting: false,
                getCallHistoryError: 'error',

            }
        }

        case types.GET_CALL_HISTORY_BY_EXTENSION_REQUEST: {
            return {
                ...state,
                getCallHistoryWaiting: true,
                getCallHistorySuccess: false,
                getCallHistoryError: '',
                callHistory: undefined

            }
        }
        case types.GET_CALL_HISTORY_BY_EXTENSION_SUCCESS: {

            return {
                ...state,
                getCallHistoryWaiting: false,
                getCallHistorySuccess: true,
                callHistory: action.data,
            }
        }
        case types.GET_CALL_HISTORY_BY_EXTENSION_ERROR: {
            return {
                ...state,
                getCallHistoryWaiting: false,
                getCallHistoryError: 'error',

            }
        }

        case types.GET_CALL_INSTRuCTION_REQUEST: {
            return {
                ...state,
                getCallInstructionWaiting: true,
                getCallInstructionSuccess: false,
                getCallInstructionError: '',
                callInstruction: null

            }
        }
        case types.GET_CALL_INSTRuCTION_SUCCESS: {

            return {
                ...state,
                getCallInstructionWaiting: false,
                getCallInstructionSuccess: true,
                callInstruction: action.data,
            }
        }
        case types.GET_CALL_INSTRuCTION_ERROR: {
            return {
                ...state,
                getCallInstructionWaiting: false,
                getCallInstructionError: 'error',

            }
        }

        case types.SET_INSTRUCTION_PAGE_POSITION: {
            return {
                ...state,
                scrollPosition: params,

            }
        }


        case types.SET_INSTRUCTION_DISPLAY_DATALIST: {
            return {
                ...state,
                displayDataList: params,

            }
        }

        case types.GET_CALL_CUSTOMER_INFO_REQUEST: {
            return {
                ...state,
                getCallCustomerInfoWaiting: true,
                getCallCustomerInfoSuccess: false,
                getCallCustomerInfoError: ''

            }
        }
        case types.GET_CALL_CUSTOMER_INFO_SUCCESS: {

            return {
                ...state,
                getCallCustomerInfoWaiting: false,
                getCallCustomerInfoSuccess: true,
                callCustomerInfo: action.data,
            }
        }
        case types.GET_CALL_CUSTOMER_INFO_ERROR: {
            return {
                ...state,
                getCallCustomerInfoWaiting: false,
                getCallCustomerInfoError: 'error',

            }
        }


        case types.GET_INSTRUCTION_LIST_REQUEST: {
            return {
                ...state,
                getInstructionListWaiting: true,
                getInstructionListSuccess: false,
                getInstructionListError: ''

            }
        }
        case types.GET_INSTRUCTION_LIST_SUCCESS: {

            return {
                ...state,
                getInstructionListWaiting: false,
                getInstructionListSuccess: true,
                instructionList: action.data,
            }
        }
        case types.GET_INSTRUCTION_LIST_ERROR: {
            return {
                ...state,
                getInstructionListWaiting: false,
                getInstructionListError: 'error',

            }
        }


        case types.GET_CALL_REPORT_BY_ID_REQUEST: {
            return {
                ...state,
                getCallReportWaiting: true,
                getCallReportSuccess: false,
                getCallReportError: ''

            }
        }
        case types.GET_CALL_REPORT_BY_ID_SUCCESS: {

            return {
                ...state,
                getCallReportWaiting: false,
                getCallReportSuccess: true,
                callReport: action.data,
            }
        }
        case types.GET_CALL_REPORT_BY_ID_ERROR: {
            return {
                ...state,
                getCallReportWaiting: false,
                getCallReportError: 'error',

            }
        }


        case types.GE_ATTACHMENT_LINK_REQUEST: {
            return {
                ...state,
                getAttachmentLinkWaiting: true,
                getAttachmentLinkSuccess: false,
                getAttachmentLinkError: '',
                attachmentLink: null

            }
        }
        case types.GE_ATTACHMENT_LINK_SUCCESS: {

            return {
                ...state,
                getAttachmentLinkWaiting: false,
                getAttachmentLinkSuccess: true,
                attachmentLink: action.data,
            }
        }
        case types.GE_ATTACHMENT_LINK_ERROR: {
            return {
                ...state,
                getAttachmentLinkWaiting: false,
                getAttachmentLinkError: 'error',

            }
        }


        case types.SAVE_CALL_REPORT_REQUEST: {
            return {
                ...state,
                saveCallReportWaiting: true,
                saveCallReportSuccess: false,
                saveCallReportError: ''

            }
        }
        case types.SAVE_CALL_REPORT_SUCCESS: {

            return {
                ...state,
                saveCallReportWaiting: false,
                saveCallReportSuccess: true,
            }
        }
        case types.SAVE_CALL_REPORT_ERROR: {
            return {
                ...state,
                saveCallReportWaiting: false,
                saveCallReportError: 'error',

            }
        }


        case types.UPDATE_CALL_REPORT_REQUEST: {
            return {
                ...state,
                updateCallReportWaiting: true,
                updateCallReportSuccess: false,
                updateCallReportError: ''

            }
        }
        case types.UPDATE_CALL_REPORT_SUCCESS: {

            return {
                ...state,
                updateCallReportWaiting: false,
                updateCallReportSuccess: true,
            }
        }
        case types.UPDATE_CALL_REPORT_ERROR: {
            return {
                ...state,
                updateCallReportWaiting: false,
                updateCallReportError: 'error',

            }
        }

        case types.GET_LOGIN_AS_REQUEST: {
            return {
                ...state,
                getLoginAsWaiting: true,
                getLoginAsSuccess: false,
                getLoginAsError: ''

            }
        }
        case types.GET_LOGIN_AS_SUCCESS: {

            return {
                ...state,
                getLoginAsWaiting: false,
                getLoginAsSuccess: true,
                loginAsResponse: action.data
            }
        }
        case types.GET_LOGIN_AS_ERROR: {
            return {
                ...state,
                getLoginAsWaiting: false,
                getLoginAsError: 'error',

            }
        }


        case types.SET_INSTRUCTION_DATA_OBJECT: {
            return {
                ...state,
                instructionDataObject: instruction

            }
        }


        case types.SET_CALL_BOX_STATUS: {
            return {
                ...state,
                callBoxStatus: params

            }
        }


        case types.SET_CALL_TRANSFER_STATUS: {
            return {
                ...state,
                callTransferStatus: params

            }
        }



        case types.GET_ALL_OPERATORS_REQUEST: {
            return {
                ...state,
                getAllOperatorsWaiting: true,
                getAllOperatorsSuccess: false,
                getAllOperatorsError: ''

            }
        }
        case types.GET_ALL_OPERATORS_SUCCESS: {

            return {
                ...state,
                getAllOperatorsWaiting: false,
                getAllOperatorsSuccess: true,
                allOperatorsResponse: action.data
            }
        }
        case types.GET_ALL_OPERATORS_ERROR: {
            return {
                ...state,
                getAllOperatorsWaiting: false,
                getAllOperatorsError: 'error',

            }
        }




        case types.GET_REPORT_RESET_PROPS: {

            return {
                ...state,
                getIdentityInfoWaiting: false,
                getIdentityInfoSuccess: false,
                getIdentityInfoError: '',
                getCallHistoryWaiting: false,
                getCallHistorySuccess: false,
                getCallHistoryError: '',
                getCallInstructionWaiting: false,
                getCallInstructionSuccess: false,
                getCallInstructionError: '',
                getCallCustomerInfoWaiting: false,
                getCallCustomerInfoSuccess: false,
                getCallCustomerInfoError: '',
                getInstructionListWaiting: false,
                getInstructionListSuccess: false,
                getInstructionListError: '',
                saveCallReportSuccess: false,
                updateCallReportSuccess: false,
                saveCallReportError: 'error',
                updateCallReportError: 'error',
                getCallReportWaiting: false,
                getCallReportSuccess: false,
                callReport: null,
                callInstruction: null


            }
        }

        default:
            return state
    }
}

export default reportReducer;